import { css } from 'styled-components';
import CaligraKids from './caligrakids/caligrakids.otf';
import DINosaurMedium from './DINosaur/DINosaurKU-Medium.woff';
import DINosaurMedium2 from './DINosaur/DINosaurKU-Medium.woff2';
import DINosaurLight from './DINosaur/DINosaurKU-Light.woff';
import DINosaurLight2 from './DINosaur/DINosaurKU-Light.woff2';
import DINosaur from './/DINosaur/DINosaurKU-Book.woff';
import DINosaur2 from './DINosaur/DINosaurKU-Book.woff2';

const FontFaces = css`
  @font-face {
    font-family: 'DINosaur';
    src:
      local('DINosaur'),
      url(${DINosaur2}) format('woff2'),
      url(${DINosaur}) format('woff');
    font-weight: 400;
    font-display: swap;
    font-style: normal;
  }

  @font-face {
    font-family: 'DINosaur';
    src:
      local('DINosaur Light'),
      local('DINosaur-Light'),
      url(${DINosaurLight2}) format('woff2'),
      url(${DINosaurLight}) format('woff');
    font-weight: 300;
    font-display: swap;
    font-style: normal;
  }

  @font-face {
    font-family: 'DINosaur';
    src:
      local('DINosaur-Medium'),
      local('DINosaur Medium'),
      url(${DINosaurMedium2}) format('woff2'),
      url(${DINosaurMedium}) format('woff');
    font-weight: 500;
    font-display: swap;
    font-style: normal;
  }

  @font-face {
    font-family: 'CaligraKids';
    src:
      local('CaligraKids'),
      url(${CaligraKids}) format('opentype');
    font-weight: 500;
    font-display: swap;
    font-style: normal;
  }
`;

export default FontFaces;
